import React from 'react';
import Translate from 'react-translate-component';

import { PersonPhoto } from './PersonPhoto';

export const PersonBlock = ({ sex, photo, birthday, firstName, lastName, middleName }) => (
    <div className="ant-row">
        <div className="person-main">
            <div className="person-photo">
                <PersonPhoto sex={sex} photo={photo} />
            </div>
            <div className='person-main-info'>
                <span>{`${lastName} ${firstName} ${middleName}`}</span>
                <span>{birthday}</span>
                <Translate content={sex} />
            </div>
        </div>
    </div>
);
